<template>
	<div class="cco-productBundles">
		<a
			class="cco-productBundles__product"
			:href="product.url"
			v-for="product in products"
			:key="product.id"
		>
			<img class="image" :src="product.image.url" :alt="product.image.title" />
			<div class="info">
				<p class="info__brand">{{ product.brand }}</p>
				<p class="info__title">{{ product.title }}</p>
				<PriceObject :price="product.price" />
			</div>
		</a>
	</div>
</template>

<script>
import PriceObject from "@/vue/components/objects/PriceObject.vue";

export default {
	name: "ProductBundles",
	components: {
		PriceObject,
	},
	props: {
		products: Object,
	},
	data: () => {
		return {};
	},
	methods: {},
	created() {},
};
</script>

<style lang="scss">
@import "@backend/scss/abstracts/variables.scss";
@import "@backend/scss/abstracts/mixins.scss";

.cco-productBundles {
	&__product {
		display: flex;
		gap: 16px;
		margin-bottom: 24px;

		.image {
			@include size-fix(64px, 64px);
		}

		.info {
			display: flex;
			flex-direction: column;
			gap: 2px;
			&__brand {
				text-transform: uppercase;
				opacity: 0.6;
				line-height: 20px;
			}
			&__title {
				font-weight: $f-semibold;
				line-height: 20px;
			}

			.ccf-price {
				font-size: $font-base-size;
				gap: 8px;
				line-height: 20px;
				margin-bottom: 0;
			}
		}

		&:last-child {
			margin-bottom: 0;
		}

		transition: $t-hover;
		&:hover {
			transition: $t-hover;
			opacity: 0.5;
		}
	}
}
</style>
